import Header from "./components/header/Header";
import Introduction from "./components/introduction/Introduction";
import Features from "./components/features/Features";
import AboutUs from "./components/aboutUs/AboutUs";
import ResultsSection from "./components/resultsSection/ResultsSection";

const Home = () => {
  return (
    <>
      <Header />
      <Introduction />
      <Features />
      <AboutUs />
    </>
  );
};

export default Home;
